<template>
    <div class='footer-copyright'>
        © 2022. Lee So Hyun. All rights reserved.
    </div>
</template>

<script>
export default {
  name: 'MainFooter',
  props: {
  }
}
</script>
